import src from "IMAGE";
export default { src, width: 237, height: 88, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAQAAAAEwYbDAAAAPklEQVR42gEzAMz/ALsjshSsCq4Orw+uDbIVuiMANEJAVD1LPU08TDdENEBAUQC4EsEgwBy4EbYPtQy0C7ULrTgQrckv9UkAAAAASUVORK5CYII="};
